import React from 'react';
import data from '../../data/volunteers.json';

const { page } = data;

export default function VolunteersHero() {
    return (
        <section className="vol-hero">
            <style>{`
                .vol-hero {
                    position: relative;
                    padding: 160px 0 90px;
                    background: var(--eventflow-black);
                    overflow: hidden; text-align: center;
                }
                .vol-hero::before {
                    content: '';
                    position: absolute; inset: 0;
                    background:
                        radial-gradient(ellipse at 50% 0%, rgba(var(--eventflow-primary-rgb),0.2) 0%, transparent 60%),
                        radial-gradient(ellipse at 80% 90%, rgba(var(--eventflow-base-rgb),0.1) 0%, transparent 50%);
                    pointer-events: none;
                }
                .vol-hero::after {
                    content: '';
                    position: absolute; inset: 0;
                    background-image:
                        linear-gradient(rgba(255,255,255,0.02) 1px, transparent 1px),
                        linear-gradient(90deg, rgba(255,255,255,0.02) 1px, transparent 1px);
                    background-size: 60px 60px;
                    pointer-events: none;
                }
                .vol-hero__inner { position: relative; z-index: 2; }
                .vol-hero__tag {
                    display: inline-flex; align-items: center; gap: 8px;
                    font-family: var(--eventflow-font);
                    font-size: 12px; font-weight: 700;
                    letter-spacing: 3px; text-transform: uppercase;
                    color: var(--eventflow-base); margin-bottom: 20px;
                }
                .vol-hero__tag::before, .vol-hero__tag::after {
                    content: ''; display: inline-block;
                    width: 28px; height: 1px;
                    background: var(--eventflow-base); opacity: 0.5;
                }
                .vol-hero__title {
                    font-family: var(--eventflow-font);
                    font-size: 64px; font-weight: 900;
                    color: #fff; line-height: 1.0;
                    letter-spacing: -2px; margin-bottom: 18px;
                }
                .vol-hero__title span {
                    background: linear-gradient(135deg, var(--eventflow-base) 0%, #ff4d9e 100%);
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                    background-clip: text;
                }
                .vol-hero__sub {
                    font-family: var(--eventflow-font);
                    font-size: 16px; color: rgba(255,255,255,0.5);
                    max-width: 600px; margin: 0 auto 36px; line-height: 1.75;
                }
                .vol-hero__note {
                    display: inline-flex; align-items: center; gap: 8px;
                    background: rgba(var(--eventflow-base-rgb),0.08);
                    border: 1px solid rgba(var(--eventflow-base-rgb),0.2);
                    border-radius: 50px; padding: 10px 24px;
                    font-family: var(--eventflow-font);
                    font-size: 13px; color: rgba(255,255,255,0.65);
                    animation: volNotePulse 3s ease-in-out infinite;
                }
                .vol-hero__note i { color: var(--eventflow-base); }
                @keyframes volNotePulse {
                    0%,100% { box-shadow: 0 0 0 0 rgba(var(--eventflow-base-rgb),0); }
                    50%     { box-shadow: 0 0 16px 4px rgba(var(--eventflow-base-rgb),0.15); }
                }
                @media (max-width: 768px) {
                    .vol-hero { padding: 130px 0 60px; }
                    .vol-hero__title { font-size: 38px; letter-spacing: -1px; }
                }
            `}</style>
            <div className="container">
                <div className="vol-hero__inner wow fadeInUp" data-wow-delay="100ms">
                    <div className="vol-hero__tag">{page.eyebrow}</div>
                    <h1 className="vol-hero__title">
                        {page.title}<br /><span>{page.titleAccent}</span>
                    </h1>
                    <p className="vol-hero__sub">{page.subtitle}</p>
                    <div className="vol-hero__note">
                        <i className="fa fa-clock" /> {page.note}
                    </div>
                </div>
            </div>
        </section>
    );
}
